export const parseBlocksAppFields = (appFields) => {
    const siteAssets = appFields.platform?.baseUrls?.siteAssets;
    if (siteAssets) {
        return {
            revision: new URLSearchParams(siteAssets).get('siteRevision'),
        };
    }
    return {};
};
//# sourceMappingURL=utils.js.map